goog.provide("shadow.js.shim.module$src$svg$objects$book_open_svg$default");
shadow.js.shim.module$src$svg$objects$book_open_svg$default = shadow.js.shim.module$src$svg$objects$book_open_svg.default;
